import { useEffect, useState } from 'react';
import { Select } from '../../../../components/inputs/Select';
import { evidenceItemsApi } from '../evidenceApi';

/**
 * TRANSFER TO PLACE as a CUSTOM-ADDING DROPDOWN — product call, 09 Oct 2026: the places this case's evidence
 * has already been deferred to, or a new one typed in. One field for the Evaluate and Transfer forms, so the
 * two cannot offer different lists. The value is the place as written — free text on the custody line.
 */
export function EvidencePlaceField({
  id,
  caseId,
  value,
  onChange,
  description,
  disabled,
  error,
}: {
  id: string;
  caseId: string | undefined;
  value: string;
  onChange: (next: string) => void;
  description: string;
  disabled?: boolean;
  error?: string;
}) {
  const [places, setPlaces] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!caseId) return;
    const controller = new AbortController();

    // A failed load leaves the list empty; a place can still be typed.
    evidenceItemsApi
      .places(caseId, controller.signal)
      .then((next) => {
        if (!controller.signal.aborted) setPlaces(next);
      })
      .catch(() => undefined)
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, [caseId]);

  return (
    <Select
      id={id}
      label="Transfer to Place"
      required
      description={description}
      placeholder="Choose or type a place"
      value={value}
      onChange={onChange}
      options={[
        ...(value && !places.includes(value) ? [{ value, label: value }] : []),
        ...places.map((p) => ({ value: p, label: p })),
      ]}
      remote
      loading={loading && Boolean(caseId)}
      allowCustom
      onCreateOption={(raw) => onChange(raw.trim().slice(0, 200))}
      disabled={disabled}
      error={error}
    />
  );
}
